import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';

const LOGO_WHITE = '/ofa_logo_dark.png';
const LOGO_DARK = '/ofa_logo_light.png';

export default function Footer() {
  const { t } = useLanguage();

  const programLinks = [
    { href: '/programs', label: t.nav.programs },
    { href: '/how-it-works', label: t.nav.howItWorks },
    { href: '/difference', label: t.nav.difference },
    { href: '/diploma', label: t.nav.diploma },
  ];

  const aboutLinks = [
    { href: '/about', label: t.nav.about },
    { href: '/returning-families', label: t.nav.returningFamilies },
    { href: '/partnerships', label: t.nav.partnerships },
    { href: '/admissions', label: t.nav.admissions },
  ];

  const contactLinks = [
    { href: '/contact', label: t.nav.bookCall },
    { href: '/tuition', label: t.nav.tuition },
    { href: '/faq', label: 'FAQ' },
  ];

  return (
    <footer
      data-testid="footer"
      className="bg-[#14274B] text-white"
      style={{ fontFamily: 'Poppins, sans-serif' }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <img
                src={LOGO_WHITE}
                alt="OFA France — École bilingue franco-américaine en ligne"
                className="h-10 w-auto"
              />
            </Link>
            <p className="text-white/70 text-sm leading-relaxed mb-4">
              {t.footer.tagline}
            </p>
            <p className="text-white/50 text-xs">
              {t.footer.partOf}
            </p>
          </div>

          {/* Programs */}
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">
              {t.footer.programs}
            </h4>
            <ul className="space-y-3">
              {programLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-white/70 hover:text-white text-sm transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* About */}
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">
              {t.footer.about}
            </h4>
            <ul className="space-y-3">
              {aboutLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-white/70 hover:text-white text-sm transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">
              {t.footer.contact}
            </h4>
            <ul className="space-y-3">
              {contactLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-white/70 hover:text-white text-sm transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-6">
              <a
                href="https://ofalycee.org"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#2D78F6] hover:text-[#66CA9D] text-sm transition-colors"
              >
                OFA Lycée USA →
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/50 text-sm">
              {t.footer.copyright}
            </p>
            <div className="flex items-center gap-6">
              <Link
                to="/privacy"
                className="text-white/50 hover:text-white text-sm transition-colors"
              >
                {t.footer.privacy}
              </Link>
              <Link
                to="/terms"
                className="text-white/50 hover:text-white text-sm transition-colors"
              >
                {t.footer.terms}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
